import React, { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";

// images
import Cookies from "universal-cookie";
import { connect, useDispatch } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import inner from "../../../assets/images/account/inner.jpg";

import { getAccountInformation } from "../../account/actions";
import { community_url } from "../../../utils/constants";
import "../style.scss";
import CustomButton from "../../../components/Buttons/CustomButton";

const cookie = new Cookies();

function MemberSuccess(props) {
  const { history } = props;
  const userToken = cookie.get("user_token");
  const dispatch = useDispatch();

  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (!userToken) {
      history.push("/login");
    }
    dispatch(getAccountInformation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8} xl={6}>
          <div
            style={{
              backgroundImage: `url(${inner})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
            className="successWrapper"
          >
            <h2>
              THANKS FOR BECOMING
              <br /> A MEMBER.
            </h2>
            <div className="didContent">
              <p className="mb-5 text-white">You’re about to gain a whole new level of clarity.</p>
              <Link onClick={handleClickTop} to="/resources">
                <CustomButton type="button" variant="marketing" gradient aria-hidden>
                  Start Exploring
                </CustomButton>
              </Link>
              <a onClick={handleClickTop} href={community_url} target="_blank" className="joinBtnWhite joinBtn ml-4" rel="noreferrer">
                <CustomButton type="button" variant="marketing" gradient aria-hidden>
                  Go To Forum
                </CustomButton>
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  user_info: state.my_account.user_info,
});

export default connect(mapStateToProps, {
  getAccountInformation,
})(withRouter(MemberSuccess));
